export class LocalStorageUtils {

  static saveAccessToken(accessToken) {
    LocalStorageUtils.saveValue('access_token', accessToken);
  }
  static saveExpiresIn(expiresIn) {
    LocalStorageUtils.saveValue('expires_in', expiresIn);
  }
  static saveRefreshToken(refreshToken) {
    LocalStorageUtils.saveValue('refresh_token', refreshToken);
  }
  static getAccessToken() {
    return localStorage.getItem('access_token');
  }
  static isExistAccessToken() {
    return localStorage.getItem('access_token') != null;
  }
  static removeAccessToken() {
    localStorage.removeItem('access_token');
  }
  static removeExpiresIn() {
    localStorage.removeItem('expires_in');
  }
  static removeRefreshToken() {
    localStorage.removeItem('refresh_token');
  }

  static saveValue(key, value) {
    if (!value) {
      return;
    }
    localStorage.setItem(key, value);
  }

  static getItem(item) {
    return localStorage.getItem(item);
  }
  static removeItem(key) {
    localStorage.removeItem(key);
  }
}

